export default __webpack_public_path__ + "static/4 1-3ec09cb8043808a3190ddc19d585b475.png";